import { Component, OnInit, Input, ViewContainerRef } from '@angular/core';
import { ModalDialogService } from 'ngx-modal-dialog';

import { UtilsService } from '../../../services/utils.service';
import { AlgOtpModalComponent} from '../../../components/dialogs/alg-otp-modal/alg-otp-modal.component';
import { BillingFrequency} from '../../../models/billingFrequency';
@Component({
  selector: 'alg-billing-frequency-footer',
  templateUrl: './alg-billing-frequency-footer.component.html',
  styleUrls: ['./alg-billing-frequency-footer.component.scss']
})
export class AlgBillingFrequencyFooterComponent implements OnInit {
  @Input() billingFrequency: BillingFrequency = {} as BillingFrequency;
  public consentsWithAdditionalProperty: Object;
  constructor(
    private utils: UtilsService,
    private modalDialogService: ModalDialogService,
    private viewContainer: ViewContainerRef

  ) { };

  ngOnInit() {
  };

  public openOTPmodal() {
    this.utils.disableOverflow();
      this.consentsWithAdditionalProperty = {
        requestId: `${this.billingFrequency.requestId}`,
        requestCode: `${this.billingFrequency.requestCode}`,
        requestType: `${this.billingFrequency.requestType}`,
        Alg_OTPCheck__c: false,
        Alg_OTPCheckDate__c: '',
        Alg_OTPPhone__c: '',
        phone: `${this.billingFrequency.phone}`,
      };

      this.modalDialogService.openDialog(this.viewContainer, {
        title: 'Un ultimo passo: verifica il tuo numero di cellulare',
        childComponent: AlgOtpModalComponent,
        settings: {
          closeButtonClass: 'close theme-icon-close',
          headerTitleClass: 'modal-title modal-title-underline textCenter',
        },
        data: {
          isConsentsOk: true,
          consents: this.consentsWithAdditionalProperty,
          phone: this.billingFrequency.phone,
          consensoType: 'billing_frequency',
        },
      });
  }

};



// WEBPACK FOOTER //
// ./src/app/components/alg-billing-frequency/alg-billing-frequency-footer/alg-billing-frequency-footer.component.ts